import React from "react";

import { FeeInformationFlyer } from "../components/fee-information-flyer";
import { MainLayout } from "../components/layout/MainLayout";

interface FeeInformationFlyerPageProps {
  dateAs?: string;
  isFbo?: boolean;
}

export const FeeInformationFlyerPage: React.FC<FeeInformationFlyerPageProps> = ({ dateAs, isFbo = false }) => {
  return (
    <MainLayout>
      <FeeInformationFlyer dateAs={dateAs} isFbo={isFbo} />
    </MainLayout>
  );
};
